/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

let resolveFn;
let setVisible = () => {};

export function showUnsavedChangesModal() {
  return new Promise((resolve) => {
    resolveFn = resolve;
    setVisible(true);
  });
}

export function handleContinue() {
  resolveFn(true);
  setVisible(false);
}

export function handleCancel() {
  resolveFn(false);
  setVisible(false);
}

export function setDialogSetter(fn) {
  setVisible = fn;
}

// Reset module-level singletons. Intended for test isolation: the dialog
// singleton retains references to a previously mounted component's state
// setter and an unresolved promise's resolver across tests, which can leak
// between test cases under slow CI timing. Test setup calls this between
// cases to guarantee a clean slate.
export function resetDialogState() {
  // Clear the setter reference BEFORE calling it to prevent stale-setter races:
  // under load, calling the old setter (which triggers React state updates on an
  // unmounting component) can interleave with the next test's beforeEach, causing
  // the hide operation to race against the new test's setup.
  const oldSetVisible = setVisible;
  setVisible = () => {};
  resolveFn = undefined;
  // Now safely call the old setter; any React updates from this will be orphaned
  // and cannot affect the next test's freshly-registered setter.
  oldSetVisible(false);
}
